module.exports = __webpack_public_path__ + "static/media/gradient-horizontal.8cd4ef18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gradient-horizontal.png
// module id = 666
// module chunks = 0